module.exports = __webpack_public_path__ + "static/media/town.603379f6.svg";